import { OriginInfo } from "@/types/index";

export const airportCodeMap = new Map<string, OriginInfo>([
  ["LON", { name: "All London Airports" }],
  ["LHR", { name: "London Heathrow", parent: "LON" }],
  ["LGW", { name: "London Gatwick", parent: "LON" }],
  ["STN", { name: "London Stansted", parent: "LON" }],
  ["LTN", { name: "London Luton", parent: "LON" }],
  ["LCY", { name: "London City", parent: "LON" }],
  ["SEN", { name: "London Southend", parent: "LON" }],
  ["BRS", { name: "Bristol" }],
  ["BHX", { name: "Birmingham" }],
  ["MAN", { name: "Manchester" }],
  ["LPL", { name: "Liverpool" }],
  ["EMA", { name: "East Midlands" }],
  ["LBA", { name: "Leeds Bradford" }],
  ["NCL", { name: "Newcastle" }],
  ["EDI", { name: "Edinburgh" }],
  ["GLA", { name: "Glasgow" }],
  ["CWL", { name: "Cardiff" }],
  ["ABZ", { name: "Aberdeen" }],
  ["BFS", { name: "Belfast" }],
  ["BOH", { name: "Bournemouth" }],
  ["SOU", { name: "Southampton" }],
  ["EXT", { name: "Exeter" }],
  ["DUB", { name: "Dublin" }],
  ["GCI", { name: "Guernsey" }],
  ["None", { name: "NA" }]
]);
